var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputMask',{attrs:{"mask":"#### #### #### ####","required":_vm.required,"label":_vm.label,"id":_vm.id},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }